import React, { ButtonHTMLAttributes } from 'react';
import './Button.scss';
// import styles from './Button.module.scss';


export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  color?: string;
  startIcon?: React.ReactElement;
  endIcon?: React.ReactElement;
}

interface InlineGroupProps {
  types?: ('button' | 'submit' | 'reset')[];
  onClicks: Array<() => void>;
  buttonClassNames?: string[];
  id?: string;
  contents: React.ReactNode[];
  disabled?: boolean[];
  justify?: 'start' | 'center' | 'end' | 'between' | 'around';
  color?: string[];
}

interface IconButtonProps {
  icon: React.ReactElement;
  tooltip?: string;
  className?: string;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
  onClick?: () => void;
  disabled?: boolean;
}

function Button({
  onClick,
  children,
  color,
  className,
  type = 'button',
  disabled = false,
  startIcon,
  endIcon,
  ...rest
}: ButtonProps): React.JSX.Element {
  return (
    <button
      className={`${className??'shared-button'} ${color??''}`}
      type={type}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      <div className='group'>
        {startIcon && <span className="button-icon">{startIcon}</span>}
        <span className='text'> {children} </span>
        {endIcon && <span className="button-icon">{endIcon}</span>}
      </div>
    </button>
  );
}

function InlineGroup({
  id,
  contents,
  onClicks,
  color = [],
  buttonClassNames = [],
  disabled = [],
  justify = 'between',
  types = [],
}: InlineGroupProps) {
  const renderButton = (index: number) => (
    <Button
      key={index}
      type={types?.[index] ?? 'button'}
      onClick={onClicks[index]}
      disabled={disabled?.[index]}
      className={buttonClassNames?.[index]}
      color={color?.[index]}
    >
      {contents[index]}
    </Button>
  );

  return (
    <div id={id} className={`inline-container justify-${justify}`} data-testid="inline-container">
      {contents.map((_, index) => renderButton(index))}
    </div>
  );
}

function IconButton({
  icon,
  tooltip,
  className,
  tooltipPosition = 'bottom',
  onClick,
  disabled,
}: IconButtonProps) {
  return (
    <div className="icon-container">
      <div className='group'>
      <button
        type="button"
        className={`icon-container-button ${className}`}
        onClick={onClick}
        disabled={disabled}
      >
        {icon}
      </button>
      {tooltip && (
        <div className={`icon-container-tooltip ${tooltipPosition}`}>
          {tooltip}
        </div>
      )}
      </div>
    </div>
  );
}

Button.InlineGroup = InlineGroup;
Button.Icon = IconButton;

export default Button;
